// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                                           from 'firebase/functions';

// ===== Interfaces =====

import {
    IPartialUserItem,
    IMigrateOldUserDataToNewItemPayload,
}                                           from '../interfaces';

const migrateOldUserDataToNewItem = async ({
    test,
    oldUser,
    oldUserEmail,
    oldUserCart,
    oldUserSessions,
    oldUserUpdateTimestamps,
}: IMigrateOldUserDataToNewItemPayload): Promise<IPartialUserItem | null> => {
    const functions = getFunctions();
    const handleMigrateOldUserDataToNewItem = httpsCallable<
        IMigrateOldUserDataToNewItemPayload,
        IPartialUserItem | null
    >(
        functions,
        'migrateOldUserDataToNewItem',
    );
    return handleMigrateOldUserDataToNewItem({
        test,
        oldUser,
        oldUserEmail,
        oldUserCart,
        oldUserSessions,
        oldUserUpdateTimestamps,
    }).then((result) => {
        const migratedUser = result.data as IPartialUserItem | null;
        return migratedUser;
    }).catch((err) => {
        throw err;
    });
};

export default migrateOldUserDataToNewItem;
